/* eslint-disable react/no-unused-class-component-methods */
'use strict';

import React, { Component } from 'react'

import _ from 'lodash'

import { CSSTransition, TransitionGroup } from 'react-transition-group'

import Layout    from '@Layout/ECFront'

import HolidaysMessage from '@/HolidaysMessage'

import FormElement from '@/Form/toolkit/FormElement'
import Form        from '@/Form/toolkit/Form'

import Loader from '@Pure/Loader'
import Link   from '@Pure/Link'

import { handleChange } from '@/Form/Functions/eventsHandling'

import getFormElement from '@/Form/Functions/getFormElement'

let config =
{
	model: 'EnterpriseCommittee'.toLowerCase(),

	fields:
	{
		'config[override][payment_CC]':
		{
			label: 'Paiement par carte de crédit',
			type: 'checkbox',
			readOnly: true
		},

		'config[override][payment_check]':
		{
			label: 'Paiement par chèque',
			type: 'checkbox',
			readOnly: true
		},

		'config[override][payment_bank_transfert]':
		{
			label: 'Paiement par virement',
			type: 'checkbox',
			readOnly: true
		},

		'config[override][payment_now]':
		{
			label: 'Paiement immédiat en tant que CE',
			type: 'checkbox',
			readOnly: true
		},

		'config[override][shipping_home]':
		{
			label: 'Livraison à domicile',
			type: 'checkbox',
			readOnly: true
		},

		'config[override][shipping_EC]':
		{
			label: 'Livraison au CE',
			type: 'checkbox',
			readOnly: true
		},

		'config[override][shipping_synergies]':
		{
			label: 'Livraison chez Synergies',
			type: 'checkbox',
			readOnly: true
		}
	}
};

const { app } = window;

export default class ECConfigPage extends Component
{
	state =
	{
		form_data: { },
		status_messages: { }
	};

	config = config;

	handleChange = handleChange.bind(this);

	getFormElement = getFormElement.bind(this);

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props;

		app.resetFunctions();

		app.push(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});

		component.handleSessionChange();
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props;

		app.delete(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});
	}

	handleValidate = (response) =>
	{
		const component = this, props = this.props;

		var form_data       = this.state.form_data;
		var status_messages = Object.assign({ }, this.state.status_messages);

		Object.keys(response.fields || { }).forEach(function (field, index)
		{
			status_messages[field] = response.fields[field];
		});

		let has_changed = false;

		if (response.success === true)
		{
			response.info = 'Mise à jour réussie.';
		}

		if (app.state.session.EC)
		{
			app.state.session.EC.config.override = response.override;

			app.emit('sessionChange');
		}

		component.setState(
		{
			status_messages: status_messages,
			form_data: form_data,
			error: response.error,
			warning: response.warning,
			info: response.info,
			created: response.created,
			loading: false
		});
	}

	handleFailure = (response) =>
	{
		const component = this, props = this.props, config = this.props.config;

		var status_messages = Object.assign({ }, this.state.status_messages);

		Object.keys(response.fields || { }).forEach(function (field, index)
		{
			status_messages[field] = response.fields[field];
		});

		component.setState(
		{
			status_messages: status_messages,
			error: response.error,
			warning: response.warning,
			info: undefined,
			loading: false
		});
	}

	handleSessionChange = () =>
	{
		const component = this, props = this.props;

		let form_data = component.state.form_data;

		if (app.state.session.EC instanceof Object === false) return;

		let override = app.state.session.EC.config.override;

		if (override instanceof Object === false) override = { };

		let override_config = _.cloneDeep(override);

		Object.keys(app.state.session.EC.config).forEach(function (field, index)
		{
			if (field === 'override') return;

			if (typeof override_config[field] === 'undefined')
			{
				override_config[field] = app.state.session.EC.config[field];
			}
		});

		Object.keys(override_config).forEach(function (field)
		{
			form_data['enterprisecommittee[config][override][' +field + ']'] =
				override_config[field];
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let base_config = app.state.session.EC ? app.state.session.EC.config : { };

		let payment_elements = [], shipping_elements = [], status;

		const form_status =
		[
			{ label: 'info', suffix: '--green' },
			{ label: 'warning', suffix: '--orange' },
			{ label: 'error', suffix: '--red' }
		];

	/**
		* Map all status from component.state and return information messages accordingly.
		*
		* @param    { Object }    status_data    Infos messages to display.
		* @param    { String }    index          Iteratof.
		*
		* @return    [Array]      Renderable React elements.
		*/
		status = form_status
		.filter(status_data => typeof state[status_data.label] !== 'undefined')
		.map(function (status_data, index)
		{
			var message =
			(
				<div key={ index } className={ 'c-form-message ' +
					'c-form-message' + status_data.suffix }>
					<div className="c-form-message__content">
						{ state[status_data.label] }
					</div>
				</div>
			);

			return message;
		});

		let elements = Object.keys(config.fields)
		.filter(function (name)
		{
			let field = name.slice(name.lastIndexOf('[') + 1, name.lastIndexOf(']'));

			return [true, 'true'].includes(base_config[field]);
		})
		.forEach(function (name, index)
		{
			let field = name.slice(name.lastIndexOf('[') + 1, name.lastIndexOf(']'));

			if (['payment_CC', 'payment_check', 'payment_bank_transfert', 'payment_now']
				.includes(field))
			{
				payment_elements.push(
					component.getFormElement(name, index, undefined, undefined, undefined, true)
				);
			}
			else
			{
				shipping_elements.push(
					component.getFormElement(name, index, undefined, undefined, undefined, true)
				);
			}
		});

		let loader =
		(
			<Loader className="c-loader" bemit={ ['white', 'bg-primary', 'view-item'] } />
		);

		if (component.state.loading !== true)
		{
			loader = undefined;
		}

		var output =
		(
			<Layout page_title="Paiement et livraison pour vos utilisateurs"
				hide_title={ true } history={ props.history }>

				<div className="page-content">

					<HolidaysMessage />

					<div className="o-content">
						<Form action="/EC-config/update" data={ state.form_data }
							hide_button={ true } className="u-no-margin-top"
							onValidate={ component.handleValidate }
							onError={ component.handleFailure }
							onSubmit={ function ()
							{
								component.setState({ loading: true });
							}}>

							<div className="c-title c-title--form">
								<h2 className="c-title__txt">
									Paiement et livraison pour les utilisateurs
								</h2>
							</div>

							<div className="c-form-message c-form-message--blue">
								<div className="c-form-message__content">
									Ne concerne pas le compte administrateur uniquement configuré par Synergies.
								</div>
							</div>

							<div className="c-form-view">

								<div className="c-title c-title--block">
									Modes de paiement des membres
								</div>

								<div className="o-grid-4 u-margin-bottom-20">
									{ payment_elements }
								</div>

							</div>

							<div className="c-form-view">

								<div className="c-title c-title--block">
									Modes de livraison des membres
								</div>

								<div className="o-grid-4 u-margin-bottom-20">
									{ shipping_elements }
								</div>

							</div>

							{ status }

						</Form>

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}
